import styled from 'styled-components'

const Styled = styled.div`
  .ant-table-thead {
    > tr {
      > th {
        background: none;
        border-bottom: 0;

        &:before {
          display: none;
        }
      }
    }
  }

  .setup-table {
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;

      li {
        .head-block {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          .module {
            flex: 1;

            .ant-typography {
              font-size: 12px;
              color: #8f9bb3;
            }
          }

          .setup {
            flex: 1;
            text-align: center;

            .ant-typography {
              font-size: 12px;
              color: #8f9bb3;
            }
          }
        }

        .item-block {
          .module-block {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .module-name {
              flex: 1;
              text-align: left;
            }
            .setup-check {
              flex: 1;
              text-align: center;
            }
          }

          .role-block {
            margin: 4px 0;

            .role-title {
              .ant-typography {
                font-size: 12px;
                color: #8f9bb3;
              }
            }
            .role-items {
              margin: 4px 0;
            }
          }

          .role-information {
            .title {
              .ant-typography {
                font-size: 12px;
                color: #8f9bb3;
              }
            }
            .information {
            }
          }
        }

        &.item {
          padding-bottom: 6px;
          margin-bottom: 6px;
          border-bottom: 1px solid #d9d9d9;
        }
      }
    }
  }
`

export default Styled
